import React, { createContext, useState } from "react";
import { toast } from "react-toastify";

import moment from "jalali-moment";
import useFetch from "./useFetch";
import { useUserData } from "./UserDataContext";
import { fixNumbers } from "../utils";
import { useLocation } from "react-router-dom";
import { useSetting } from "./SettingContext";
const CustomerBasketContext = createContext();

const CustomerBasketProvider = (props) => {
  const { showNumSix } = useSetting();

  const [userSelectedRing, setUserSelectedRing] = useState([]);
  const { userData } = useUserData();
  const [lastItem, setLastIetm] = useState();
  const [getDataBasket, setGetDataBasket] = useState();
  const [selectedUserContext, setSelectedUserContext] = useState(undefined);
  const [postDataBasket, setPostDataBasket] = useState();
  const [orderItemEditRing, setOrderItemEditRing] = useState(null);
  const [selectedBangle, setSelectedBangle] = useState(null);

  const location = useLocation();

  const createHistoryBasket = useFetch({
    method: "post",
    url: "UserBasketHistory_Service",
    data: postDataBasket,
    argFunc: (res) => {
      let bf = [...userSelectedRing];
      bf[lastItem].history_id = res.id;
      setUserSelectedRing(bf);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const updateHistoryBasket = useFetch({
    method: "patch",
    url: `UserBasketHistory_Service/${orderItemEditRing}`,
    trigger: false,
    data: { bangle: selectedBangle },
    argFunc: (res) => {
      getHistoryBasket.reFetch();
      // toast.success("سفارش با موفقیت  منتقل شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const handleEditRing = (order_item_id, selected_ring) => {
    setOrderItemEditRing(order_item_id);
    setSelectedBangle(selected_ring);
    updateHistoryBasket.reFetch();
  };
  const [selectedHistoryItem, setSelectedHistoryItem] = useState();
  const deleteHistoryBasket = useFetch({
    method: "delete",
    url: `UserBasketHistory_Service/${selectedHistoryItem}`,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const getHistoryBasket = useFetch({
    method: "get",
    trigger: true,
    url: `User_Service/${userData.username}/get_current_basket`,
    argFunc: (res) => {
      let a = [];

      res.map((it, ind) => {
        a.push({
          ring: it.bangle,
          nums: showNumSix
            ? [
                it.size_one_num,
                it.size_two_num,
                it.size_three_num,
                it.size_four_num,
                it.size_five_num,
                it.size_six_num,
              ]
            : [
                it.size_one_num,
                it.size_two_num,
                it.size_three_num,
                it.size_four_num,
                it.size_five_num,
              ],
          date: it.date,
          from_hostory: true,
          history_id: it.id,
        });
      });
      if (res.length > 0) {
        setSelectedUserContext(res[0].user);
      }
      setUserSelectedRing(a);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const AddRing = (newItem, itemNums, dateValue, selectedUser = null) => {
    let sz = itemNums.length;
    if (sz == 6) {
      setPostDataBasket({
        bangle: newItem.id,
        size_one_num: itemNums[0] == "" ? 0 : itemNums[0],
        size_two_num: itemNums[1] == "" ? 0 : itemNums[1],
        size_three_num: itemNums[2] == "" ? 0 : itemNums[2],
        size_four_num: itemNums[3] == "" ? 0 : itemNums[3],
        size_five_num: itemNums[4] == "" ? 0 : itemNums[4],
        size_six_num: itemNums[5] == "" ? 0 : itemNums[5],
        date: moment(dateValue).locale("en").format("YYYY-MM-DD"),
        user:
          userData.job == "Admin"
            ? selectedUserContext !== undefined
              ? selectedUserContext.username
              : selectedUser != undefined
              ? selectedUser.username
              : null
            : userData.username,
        // from_admin: props.AdminCreateOrderForUser
      });
    } else {
      setPostDataBasket({
        bangle: newItem.id,
        size_one_num: itemNums[0] == "" ? 0 : itemNums[0],
        size_two_num: itemNums[1] == "" ? 0 : itemNums[1],
        size_three_num: itemNums[2] == "" ? 0 : itemNums[2],
        size_four_num: itemNums[3] == "" ? 0 : itemNums[3],
        size_five_num: itemNums[4] == "" ? 0 : itemNums[4],
        date: moment(dateValue).locale("en").format("YYYY-MM-DD"),
        user:
          userData.job == "Admin"
            ? selectedUserContext !== undefined
              ? selectedUserContext.username
              : selectedUser != undefined
              ? selectedUser.username
              : null
            : userData.username,

        // user:props.selectedUser.username
      });
    }

    let before = [...userSelectedRing];
    if (
      before.some(
        (ri) =>
          ri.ring.id == newItem.id &&
          ri.ring.gender == newItem.gender &&
          newItem.color == ri.ring.color
      )
    ) {
      toast.error("النگو قبلا اضافه شده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      setLastIetm(userSelectedRing.length);

      if (location.state == null) {
        createHistoryBasket.reFetch();
      }

      setUserSelectedRing([
        ...before,
        {
          ring: newItem,
          nums: itemNums,
          date: dateValue,
          from_hostory: false,
          history_id: null,
        },
      ]);
    }
  };
  const removeRing = (ind) => {
    let before = [...userSelectedRing];
    let d = before[ind];
    // if (d.from_hostory) {
    setSelectedHistoryItem(d.history_id);
    deleteHistoryBasket.reFetch();
    // }
    before.splice(ind, 1);
    setUserSelectedRing(before);
  };
  //? data sample
  // [
  //   {
  //     nums:[],
  //     ring:{}
  //   }
  // ]
  const updateRingNumUsingIndex = (ringIndex, numIndex, newValue) => {
    let before = [...userSelectedRing];

    before[ringIndex]["nums"][numIndex] = fixNumbers(newValue);

    setUserSelectedRing(before);
  };

  const updateRingDateUsingIndex = (ringIndex, newValue) => {
    let before = [...userSelectedRing];

    before[ringIndex]["date"] = newValue;

    setUserSelectedRing(before);
  };

  const clearBasket = () => {
    setUserSelectedRing([]);
    setSelectedUserContext(undefined);
  };
  return (
    <CustomerBasketContext.Provider
      value={{
        userSelectedRing,
        AddRing,
        removeRing,
        updateRingNumUsingIndex,
        updateRingDateUsingIndex,
        clearBasket,
        selectedUserContext,
        setSelectedUserContext,
        handleEditRing,
      }}
      {...props}
    >
      {props.children}
    </CustomerBasketContext.Provider>
  );
};

const useCustomerBasket = () => React.useContext(CustomerBasketContext);

export { CustomerBasketProvider, useCustomerBasket };
